import React, { createContext } from "react";

export const errorHandlerContext = createContext({
  msgConfig: null,
  setMsgConfig: null,
});
